import { render, staticRenderFns } from "./ReportI002.vue?vue&type=template&id=318df7b0"
import script from "./ReportI002.vue?vue&type=script&lang=js"
export * from "./ReportI002.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports